import { render, staticRenderFns } from "./FormGetFreebieProductBySKU.vue?vue&type=template&id=268b749a&scoped=true&"
import script from "./FormGetFreebieProductBySKU.vue?vue&type=script&lang=js&"
export * from "./FormGetFreebieProductBySKU.vue?vue&type=script&lang=js&"
import style0 from "./FormGetFreebieProductBySKU.vue?vue&type=style&index=0&id=268b749a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b749a",
  null
  
)

export default component.exports